import { Button, Replace } from '@sparemin/blockhead';
import React from 'react';
import useRestoreVideo from 'hooks/useRestoreVideo';

export interface ArchivedVideoSectionRestoreButtonProps {
  embedVideoId: number;
  onRestoreSuccess?: () => void;
}

const ArchivedVideoSectionRestoreButton: React.FC<ArchivedVideoSectionRestoreButtonProps> = ({
  embedVideoId,
  onRestoreSuccess,
}) => {
  const { isRestoring, onRestoreVideo } = useRestoreVideo({
    embedVideoId,
    onRestoreSuccess,
  });

  return (
    <Button
      fluid
      variant="special"
      isDisabled={isRestoring}
      startIcon={<Replace />}
      onPress={onRestoreVideo}
    >
      restore now
    </Button>
  );
};

export default ArchivedVideoSectionRestoreButton;
